// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import YuqueOutlinedSvg from "@fishx/icons-svg/es/asn/YuqueOutlined";
import FishxIcon from '../components/FishxIcon';

var YuqueOutlined = function YuqueOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: YuqueOutlinedSvg
  }));
};

YuqueOutlined.displayName = 'YuqueOutlined';
export default React.forwardRef(YuqueOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/YuqueOutlined.js
// module id = 4428
// module chunks = 0